/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

export type CreatePayoutRequestSourceOfFunds = typeof CreatePayoutRequestSourceOfFunds[keyof typeof CreatePayoutRequestSourceOfFunds];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreatePayoutRequestSourceOfFunds = {
  income: 'income',
  household: 'household',
  'friends-loan': 'friends-loan',
  'company-fund': 'company-fund',
  'personal-investment': 'personal-investment',
  'personal-savings': 'personal-savings',
  wages: 'wages',
} as const;
